import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import CustomerDashboardPageTemplate from 'components/consumer/CustomerDashboardPageTemplate';
import OrderInfo from 'components/consumer/user-orders-info/OrderInfo';
import FAQCommonQuestions from 'components/consumer/user-orders-build-updates/FAQCommonQuestions/FAQCommonQuestionsUI';
import { faqs } from 'components/consumer/user-orders-build-updates';
import InvalidTrackingRequest from './InvalidTrackingRequest';

// const orderTrackingInfo = {
//   tracking_info: {"errors":null,"order_id":"226433","order_date":"May 9 2020","rdc_city":"Upper Marloboro","rdc_state":"MD","display_ship_date":"May 23 2020","display_arriving_date":"Jun 7 2020","display_delivery_date":"Jun 22 2020","carrier":"La-Z-Boy Home Delivery","progress":4,"mainTitle":"Estimated shipping May 23 2020","displayDeliveryRange":"Jun 17 2020-Jun 22 2020","order":{"order_id":"226433","order_type":"Normal","order_note":"","order_status":"Released For Production","order_paynow":"Yes","payment_status":"Charged","delivery_date":null,"total_order_amount":4439.7002,"shipping":{"address_name":null,"address_first_name":"Candice","address_last_name":"White","address_street1":"8899 Papillon Drive","address_street2":null,"address_city":"Ellicott City","address_country":"US","address_state":"MD","address_zip_code":"21043","address_phone":"(443) 676-2963","address_fax":null,"__typename":"Address"},"__typename":"OrderInfoMinimum"},"order_items":[{"product_id":"2581","product_type":"0","quantity":"1","name":"Eliot Leather Sectional with Bumper (2 piece)","total_cost":"5850.0000","variants_sku":"-CL044-WS03-LFB","variants_text":"<dt>Leather</dt><dd>Santiago Camel</dd><dt>Wood Stain</dt><dd>Mocha</dd><dt>Orientation</dt><dd>Left</dd>","upholstery":"Santiago Camel","wood_stain":"Mocha","option_value_ids":"4219,757,3260","goal_date":"2020-05-23","eta_delivery_start":"2020-06-02","eta_delivery_end":"2020-06-08","eta_delivery_all":"{\"start\":\"2020-06-02\",\"end\":\"2020-06-08\",\"short_format\":\"Jun 02 - Jun 08\",\"long_format\":\"Jun 02, 2020 - Jun 08, 2020\"}","shipping_status":null,"tracking_url":null,"tracking_note":null,"tracking_number":null,"carrier":null,"shipped_date_f":null,"small_image":"image_2581_109.jpg",          "sizes_text": "<dt>Size</dt><dd>104\"w x 84\"d x 33\"h</dd>","url_key":"/sectional-bumpers/eliot-leather-sectional-with-bumper/","__typename":"OrderItemsInfoMinimum"}],"__typename":"OrderTrackingWithZipResponse"}
// };

const TrackOrderStatusView = t0 => {
  const $ = _c(7);
  const {
    state
  } = t0;
  const trackingInfo = state.tracking_info;
  let order;
  if ($[0] !== trackingInfo) {
    order = {
      ...trackingInfo,
      ...trackingInfo.order
    };
    delete order.order;
    $[0] = trackingInfo;
    $[1] = order;
  } else {
    order = $[1];
  }
  const t1 = `Order J-${order.order_id}`;
  let t2;
  if ($[2] !== order) {
    t2 = order.order_items.map ? <div className="w-full min-h-[60vh] flex flex-col-reverse lg:flex-row lg:justify-between"><div className="lg:w-[55%]"><OrderInfo order={order} showSignInPageUponSelection={true} /></div><div className="lg:w-[42%]"><FAQCommonQuestions steps={faqs} /></div></div> : <InvalidTrackingRequest />;
    $[2] = order;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="bg-white" data-xc="track-order-status-view"><CustomerDashboardPageTemplate title={t1}>{t2}</CustomerDashboardPageTemplate></div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
TrackOrderStatusView.propTypes = {
  state: PropTypes.shape({
    tracking_info: PropTypes.shape({
      order: PropTypes.shape({
        order_id: PropTypes.string,
        order_items: PropTypes.shape({
          map: PropTypes.func
        })
      })
    })
  })
};
export default TrackOrderStatusView;